import map from "lodash/map";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Suspense, useEffect } from "react";

import routes from "./routes";
import Layout from "./components/Layout";
import themedLazy from "./utils/themedLazy";

import "./App.css";
import { trackPageView } from "./utils/pixel";

// Trang quản trị /dashboard (dựng lại 10/2026) — tải riêng, khách không bao giờ tải; tự kiểm quyền admin/nhân viên
const DashboardApp = themedLazy(() => import("./dashboard/DashboardApp"));

const PixelPageView = () => {
  const location = useLocation();
  useEffect(() => { trackPageView(); }, [location.pathname]);
  return null;
};

const Spinner = () => (
  <span className="h-8 w-8 animate-spin rounded-full border-[3px] border-brand-100 border-t-brand-600" role="status" aria-label="Đang tải" />
);

// Chờ file JS của trang: header/footer đã hiện (Suspense nằm TRONG Layout); min-h giữ footer dưới màn hình
const PageFallback = () => (
  <div className="flex min-h-screen items-start justify-center pt-24">
    <Spinner />
  </div>
);

const FullFallback = () => (
  <div className="flex min-h-screen items-center justify-center">
    <Spinner />
  </div>
);

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <PixelPageView />
      <Suspense fallback={<FullFallback />}>
      <Routes>
        <Route path="/dashboard/*" element={<DashboardApp />} />
        {map(routes, (route) => {
          const Element = route.element;
          return (
            <Route
              path={route.path}
              key={route.path}
              element={
                <Layout>
                  <Suspense fallback={<PageFallback />}>
                    <Element />
                  </Suspense>
                </Layout>
              }
            />
          );
        })}
      </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
